<template>
  <div class="user-profile_profile colorBorder">
    <img v-if="headUrl" class="user-profile_profile-head" :class="{'userprofile-active':userId.length > 0}" :src="headUrl" alt="头像" @click="routeToUser()"/>
    <img v-else class="user-profile_profile-head" :class="{'userprofile-active':userId.length > 0}" src="@/assets/img/user.png" @click="routeToUser()"/>
    <div class="user-profile_profile-name" :class="{'userprofile-active':userId.length > 0}" @click="routeToUser()">{{userName}}</div>
    <div class="user-profile_profile-number">
      文章数：
      <span class="text-color">{{articleTotal ?articleTotal : '0'}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserProfile',
  props: {
    userName: { type: String, default:'' },
    headUrl: { type: String, default:'' },
    articleTotal: { type: [String,Number], default: '' },
    userId: { type: String, default:'' }
  },
  methods: {
    routeToUser() {
      if (this.userId.length > 0) {
        const url = `/user-article-list/${this.userId}`
        if(this.$route.path === url) return
        this.$router.push(`${url}?userName=${this.userName}&headUrl=${this.headUrl || ''}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.colorBorder {
  background: #fff;
  border: 1px solid rgba(229,230,233,1);
}
.userprofile-active {
  cursor: pointer;
  &:hover {
    color: #1740DC;
  }
}
.user-profile {
  &_profile {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0 30px;
    &-head {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      border: 1px solid #e5e6e9;
      margin-bottom: 10px;
    }
    &-name {
      margin-bottom: 5px;
      font-size: 12px;
      color: #040C2C;
      line-height: 18px;
      font-weight: 600;
    }
    &-number {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(4,12,44,0.45);
      line-height: 18px;
      font-weight: 400;
     .text-color {
        font-size: 14px;
        font-weight: 600;
      }
    }
  }
}
</style>